export default __webpack_public_path__ + "static/media/30-TurquoiseWaters.aced3c3c.jpeg";